<template>
  <div class="elr-input-group">
    <label :for="fieldName">{{required ? '* ' : ''}}{{label}}:</label>
    <input
      :id="fieldName"
      :type="type"
      :placeholder="placeholder ? placeholder : label"
      :name="fieldName"
      :value="value"
      :class="{ 'has-error': errorMessage }"
      :aria-required="required"
      @input="$emit('input', $event.target.value)"
    >
    <small class="elr-input-support" v-if="supportText">{{supportText}}</small>
    <small class="error-message" v-if="errorMessage">
      {{errorMessage}}
    </small>
  </div>
</template>

<script>
export default {
  name: 'InputText',
  props: {
    label: {
      type: String,
      required: true
    },
    fieldName: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    errorMessage: {
      type: String
    },
    required: {
      type: Boolean
    },
    supportText: {
      type: String
    },
    placeholder: {
      type: String
    },
    type: {
      type: String,
      default: 'text'
    }
  },
}
</script>

<style lang="scss" scoped>

@import '../../assets/sass/config';

input {
  border: 1px solid #999;
  min-height: 40px;
  font-size: 14px;
}

.has-error {
  border-color: $red;
}

.error-message,
.elr-form small.error-message {
  color: $red;
  margin-bottom: 0 !important;
}

.elr-input-support {
  margin-bottom: 0;
}
</style>

